<template>
  <div v-if="modals !== null">
    <UserBanModal
        :modal-data="modals.userBanModal"
        @close="closeNotification"
    />
    <SimpleModal
        :modal-data="modals.simpleModal"
        @close="closeNotification"
    />
  </div>
</template>


<script>

import UserBanModal from "./components/userBanModal.vue";
import SimpleModal from "./components/simpleModal.vue";
import BaseAdminMixin from "../../../../../admin/components/mixins/BaseAdminMixin.vue";

export default {
  name: "mainModal",
  props: ['user'],
  mixins: [
    BaseAdminMixin
  ],
  components: {UserBanModal, SimpleModal},
  data() {
    return {
      modals: null,
    }

  },
  mounted() {
    this.getNotificationModals();
  },
  methods: {
    async getNotificationModals() {
      if (!this.user) {
        return;
      }
      const response = await this.sendRequest('cabinet/client/notification/getNotificationModals', 'get');
      this.modals = response.notificationModals;
    },
    async closeNotification(id) {
      await this.sendRequest('cabinet/client/notification/close', 'post', {notificationId: id});
    }
  },
}
</script>